import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import json from "../translations.json"
import "../styles/entry.scss"
import "../styles/lateral.scss"

const Lateral = props => {
  const { path } = props
  let [email, setEmail] = useState("")
  const style = { display: "block" }
  const recipes = [
    {
      en: {
        title: "Keto blueberry flat cake",
        path: "/en/recipe/blueberry-flat-cake",
      },
      es: {
        title: "Bizcocho de arándanos",
        path: "/es/recipe/keto-bizcocho-arandanos",
      },
      image: "keto-blueberry-flat-cake.webp",
    },
    {
      en: { title: "Keto eggs Benedict", path: "/en/recipe/eggs-benedict" },
      es: { title: "Keto huevos benedict", path: "/es/recipe/huevos-benedict" },
      image: "keto-egg-benedict.webp",
    },
    {
      en: {
        title: "Chilean Cocimiento",
        path: "/en/recipe/cocimiento",
      },
      es: {
        title: "Cocimiento Chileno",
        path: "/es/recipe/cocimiento",
      },
      image: "cocimiento.webp",
    },
  ]
  let [windowWidth, setWindowWidth] = useState(0)
  let { language } = props

  useEffect(() => {
    setWindowWidth(window.innerWidth)
    window.adsbygoogle = window.adsbygoogle || []
    window.adsbygoogle.push({})
  }, [path])

  const handleInputChange = event => {
    const { target } = event
    setEmail(target.value)
  }

  const { showAbout } = props

  return (
    <div className="lateral-section">
      {/* <div className="subscribe">
        <p>¡Entérate de las últimas novedades!</p>
        <form onSubmit={event => handleSubmit(event)}>
          <input
            className="input-subscribe"
            name="email"
            value={email}
            type="text"
            placeholder="Email"
            onChange={event => handleInputChange(event)}
          />
          <div>
            <input
              className="subscribe-button"
              type="submit"
              value="Suscribirse"
            />
          </div>
        </form>
      </div> */}
      {showAbout ? (
        <div className="lateral-about">
          <div className="lateral-about-img-container">
            <img
              data-pin-nopin
              className="lateral-about-img"
              src="https://vivelocarb.s3-eu-west-1.amazonaws.com/me2.webp"
              alt="giselle santin"
            />
          </div>
          <div className="lateral-about-text">
            <p>{language && json[language].hi}</p>
            <p>{language && json[language].aboutShort}</p>
            <a className="about-link" href="/aboutme">
              {language && json[language].more} →
            </a>
          </div>
        </div>
      ) : null}
      <div key={path} style={{ width: "99%" }}>
        <ins
          className="adsbygoogle"
          style={{ display: "block" }}
          data-ad-client="ca-pub-8092084840885351"
          data-ad-slot="5219499175"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      </div>
      <div className="lateral-favorite">
        <div>
          <p className="lateral-favorite-text">
            {language && json[language].favorite}
          </p>
          <div className="lateral-favorite-recipe-container">
            {recipes.map((recipe, index) => (
              <Link key={index} to={language ? recipe[language].path : ""}>
                <img
                  data-pin-nopin
                  className="favorite-recipes"
                  src={`https://vivelocarb.s3-eu-west-1.amazonaws.com/${recipe.image}`}
                  alt={language ? recipe[language].title : ""}
                />
                <div className="lateral-recipe-title">
                  {language ? recipe[language].title : ""}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Lateral
